import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResidentCustomPublicationConsent } from 'types/publishedAssets';
import { ConsentInfoTooltip } from './ConsentInfoTooltip';
import styles from './NotificationSignup.module.scss';

interface Props {
  /** Pre-translated unsubscribe copy. Contains a privacy-policy anchor. */
  html: string;
  consents?: ResidentCustomPublicationConsent[];
}

/**
 * Legal block under the signup form. Two lines, per the design: the email-usage
 * sentence carrying the consent info trigger, then the unsubscribe sentence.
 */
export function SignupDisclaimer({ html, consents = [] }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.legal}>
      <div className={styles.consentLine}>
        <span className={styles.disclaimer}>{t('notificationSignup.emailUsageNotice')}</span>
        <ConsentInfoTooltip consents={consents} />
      </div>
      <div className={styles.disclaimer} dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
